import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ConsultaArquivosImportacaoFuncionariosService } from './consulta-arquivos-importacao-funcionarios.service';
import { Location } from '@angular/common';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { DatatableService } from '../../../../../shared/services/datatable.service';
import { IMyDpOptions } from 'mydatepicker';
import { HttpParams } from '@angular/common/http';
import { SpringDatatablePaginationService } from '../../../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { SpringDatatablePagination } from '../../../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { EncriptyUtilService } from '../../../../../shared/services/encripty-util.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DateUtilService } from '../../../../../shared/services/date-util.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from 'angular2-notifications';
import localePtBr from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localePtBr);
@Component({
  selector: 'ngx-consulta-arquivos-importacao-funcionarios',
  templateUrl: './consulta-arquivos-importacao-funcionarios.component.html',
  styleUrls: ['./consulta-arquivos-importacao-funcionarios.component.scss']
})
export class ConsultaArquivosImportacaoFuncionariosComponent implements OnInit, OnDestroy {

  spinnerLoad: boolean = false;
  tableLimit = 10;
  public formSearch: FormGroup = null;
  public listStatus: Array<any> = [];

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su"
  };


  @ViewChild('myTable', null)
  public myTable: DatatableComponent;
  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();
  public customLogin = null;

  constructor(
    private location: Location,
    private datatableService: DatatableService,
    private service: ConsultaArquivosImportacaoFuncionariosService,
    private formBuilder: FormBuilder,
    private paginationService: SpringDatatablePaginationService,
    private encriptyService: EncriptyUtilService,
    private router: Router,
    private route: ActivatedRoute,
    private dateUtilService: DateUtilService,
    private spinnerService: NgxSpinnerService,
    private notificationService: NotificationsService,
  ) {
    this.service.searchFileImportEmployeeStatus(null, (response) => {
      this.listStatus = response;
    }, null);
    this.paginationService.setDatatablePagination(this.datatablePagination);
  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);

    this.formSearch = this.formBuilder.group({
      nomeArquivo: [null],
      dataInicio: [null],
      dataFim: [null],
      status: [null],
    });
    this.fillFilesImport(this.formSearch.value);
  }

  ngOnDestroy() {
    this.datatableService.unsubscribeTable(this.myTable);
  }

  fillFilesImport(data?: any, page?: string) {
    let params = new HttpParams();
    params = params.append('size', String(this.tableLimit));
    params = params.append('sort', 'id,desc');

    if (page) {
      params = params.append('page', page);
    }

    if (data) {


      if (data.nomeArquivo != null && String(data.nomeArquivo).trim() !== '') {
        params = params.append('nomeArquivo', data.nomeArquivo);
      }

      if (data.dataInicio != null) {
        let dataInicio = this.dateUtilService.datepickerTransformDate(data.dataInicio, 'YYYY-MM-DD');
        params = params.append('dataInicio', dataInicio);
      }

      if (data.dataFim != null) {
        let dataFim = this.dateUtilService.datepickerTransformDate(data.dataFim, 'YYYY-MM-DD');
        params = params.append('dataFim', dataFim);
      }

      if (data.status != null) {
        params = params.append('status', data.status);
      }

    }

    this.spinnerService.show();
    this.service.searchImportFiles(params, (response) => {
      this.paginationService.setInfo(response);
      this.spinnerService.hide();

    }, (error) => {
      this.notificationService.error("Não foi possível carregar as informações.")
      this.spinnerService.hide();
    });
  }

  goToImportationView(fileId: any) {
    let fileIdEnc = this.encriptyService.encriptyBySecretKey('' + fileId);

    let params = {
      'arquivoId': fileIdEnc,
    };
    this.router.navigate(['../consulta-importacao-funcionarios'], { relativeTo: this.route, queryParams: params });

  }


  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
